import React from 'react';
import { RRow } from 'recruit/components';
import TandemLogo from 'assets/images/NavyLogo.svg';

export default function LogoBar({ height = 40 }: { height?: number }) {
    return (
        <RRow fullWidth justify="center" align="center">
            <TandemLogo style={{ height }} />
        </RRow>
    );
}
